import React from 'react';
import { Link } from 'react-router-dom';
import { useParallax } from '../lib/scrollFX';

const KEYWORDS = ['Engineer', 'AI Builder', 'Dog Dad', 'Chill Guy'];

export default function Hero({ content }) {
  const bgRef = useParallax();

  const greeting = content?.greeting ?? "Hey, I'm";
  const nameFirst = content?.nameFirst ?? 'Parth';
  const nameLast = content?.nameLast ?? 'Merchant';
  const keywords = Array.isArray(content?.keywords) && content.keywords.length > 0
    ? content.keywords
    : KEYWORDS;

  return (
    <section className="hero hero-h64" ref={bgRef}>
      {/* Decorative backdrop — perspective grid + horizon + mountain-range silhouette */}
      <div className="dg-chat-backdrop" aria-hidden>
        <i className="dg-spotlight" /><i className="dg-grid-wall" />
        <i className="dg-horizon" /><i className="dg-grid-floor" />
      </div>

      <div className="hero-inner hero-inner-centered">
        <div className="hero-avatar-wrap">
          <span className="hero-avatar-ring" aria-hidden="true" />
          <span className="hero-avatar-glow" aria-hidden="true" />
          <img className="hero-avatar" src="/parthm.png" alt="Parth Merchant" />
          <span className="hero-status-dot" aria-hidden="true" />
        </div>

        <div className="hero-text">
          <p className="hero-greeting">{greeting}</p>
          <h1 className="hero-title">
            {nameFirst} <span className="hero-title-accent">{nameLast}</span>
            <span className="hero-title-dot">.</span>
          </h1>

          <ul className="hero-keywords" aria-label="What I'm about">
            {keywords.map((word, i) => (
              <li
                className="hero-keyword"
                key={word}
                style={{ '--kw-i': i }}
              >
                {word}
              </li>
            ))}
          </ul>

          <div className="hero-actions">
            <Link to="/blog" className="btn-primary">Read the Blog</Link>
            <a href="#about" className="btn-ghost">About me</a>
          </div>
        </div>
      </div>

      <a href="#about" className="hero-scroll-cue" aria-label="Scroll to about">
        <span className="hero-scroll-text">Scroll</span>
        <span className="hero-scroll-line" aria-hidden="true" />
      </a>
    </section>
  );
}
